import React, { useRef, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Grid, Button, Box } from '@mui/material';
import {
  PageContainer,
  FilterPod,
  TableComponents,
  SimpleDialog,
  ButtonLoading,
  LoadingPage,
} from 'components';
import { toFilterVOS, filterVOStoQueryStr } from 'components/FilterPod';
import { columns, generateData } from './components/Columns';
import Services from '../services/Services';
import InitFilters from './constants/InitFiltering';
import { useStyles } from './style';
import useCustomHook from '../hooks';
import FilterButton from 'components/FilterPod/FilterButton';
import { getDynamicObjectAction, constBreadCrumbsTitle } from 'utility';
import axios from 'axios';

const TicketSale = () => {
  //-- STATES --//
  let tableRef = useRef();
  const [openFilterDialog, setOpenFilterDialog] = useState(false);
  const handleCloseFilterDialog = () => setOpenFilterDialog(false);

  const {
    loading,
    setLoading,
    categoryLoading,
    setCategoryLoading,
    setFilterParams,
    size,
    setSize,
    page, setPage,
    filters,
    setFilters,
    dialog,
    setDialog,
    loadingBtn,
    setLoadingBtn,
    projectId, setProjectId,

  } = useCustomHook();
  //--HOOKS--//
  const classes = useStyles();
  const navigate = useNavigate();
  const actionsList =
    getDynamicObjectAction([
      'contentTicketListSalePage',
      'createTicketSalePage',
      'contentTicketListDetailSalePage',
      'contentTicketListCloseSalePage',
      'contentTicketListCancelSalePage'

    ])
  useEffect(() => {
    if (actionsList['contentTicketListSalePage']) {
      setCategoryLoading(true);
      getSaleCategory();
    } else {
      setCategoryLoading(false);

    }
  }, []);

  //دریافت لیست دسته بندی ها
  const getSaleCategory = async () => {
    setLoading(true);
    setFilters(null);
    try {
      const res = await Services.getTicketingSale();
      const cat = res?.result;
      const projects = cat?.projects;
      const tempFilters = InitFilters();
      setProjectId(projects[0]?.id)
      tempFilters[0] = {
        ...tempFilters[0],
        filterProps: {
          ...tempFilters[0]?.filterProps,
          options: projects[0].states.map((project) => ({
            value: String(project?.name).toUpperCase(),
            label: project?.title,
          })),
        },
        value: null,
      };
      //اعمال در فیلتر ها

      onFiltersChange(tempFilters, true);
      setCategoryLoading(false);
    } catch (error) {
      setLoading(false);
      setCategoryLoading(false);
    }
  };

  // دریافت لیست درخواست  ها در جدول
  const getList = async (query) => {
    // شرط اولیه در صورت خالی بودن فیلتر ها

    try {
      setLoading(true);
      let filter = toFilterVOS([...filters]);
      let queries = filterVOStoQueryStr(filter);
      let params = {
        offset: query ? query?.pageNumber * query?.pageSize : page * size,
        size: query ? query?.pageSize : size,
        ...queries,
      };
      if (params['fromDate']) {
        params['fromDate'] = params?.fromDate.split(' ')[0];
      }
      if (params['toDate']) {
        params['toDate'] = params?.toDate.split(' ')[0];
      }

      const data = {
        filterVOS: [],
        parentParams: [],
        orderByElementVOS: [],
      };

      setFilterParams({ data, params });
      // پس از دریافت شناسه از سرویس sale ، به این سرویس درخواست زده یمششود و دیتا در جدول قرار میگیرید
      const res = await Services.getTicketingSaleRequest(params, projectId);
      let list = [];

      list = generateData(res?.result, {
        page: query ? query?.pageNumber : page,
        pageSize: query?.pageSize || size,
      });
      setLoading(false);

      let d = {
        data: list,
        page: query ? query?.pageNumber : page,
        totalCount: res?.count,
      };

      return d;
    } catch (error) {
      if (axios.isCancel(error)) {
        setLoading(true);
      } else {
        setLoading(false);
        return {
          data: [],
          page: query ? query?.pageNumber : page,
          totalCount: 0,
        };
      }
    }
  };

  // سرویس مربوط به بستن درخواست  
  const closeTicketRequest = async (ticket) => {
    setLoadingBtn(true);
    try {
      const params = { 'workItemId': ticket?.Id };
      await Services.updateCloseSaleTicket(ticket?.Id, ticket?.ProjectId, params);
      setTimeout(() => {
        tableRef?.current?.onChangeTable();
      }, 100)
    } catch (error) {
    } finally {
      setLoadingBtn(false);
      handleCloseDialog(ticket, 'close');
    }
  };

  // سرویس مربوط به کنسل کردن درخواست  
  const cancelTicketRequest = async (ticket) => {
    setLoadingBtn(true);
    const params = { 'workItemId': ticket?.Id };

    try {
      await Services.updateCancelSaleTicket(ticket?.Id, ticket?.ProjectId, params);

      setTimeout(() => {
        tableRef?.current?.onChangeTable();
      }, 100)
    } catch (error) {
    } finally {
      setLoadingBtn(false);
      handleCloseDialog(ticket, 'cancel');
    }
  };

  //-- OTHER FUNCTIONS --//
  const onFiltersChange = (newFilters, isNotRequest) => {
    setFilters(newFilters);
    setPage(0)
    setSize(10)
    if (!isNotRequest) {
      setTimeout(() => {
        tableRef?.current?.onChangeTable(true);
      }, 100)
    }

  };

  const handleCloseDialog = (ticket, item) => {

    let data = {
      title: ` ${item === 'cancel' ? 'کنسل کردن درخواست  ' : ' بستن درخواست '} ${ticket.Name} `,
      content: `آیا از ${item === 'cancel' ? 'کنسل کردن درخواست  ' : ' بستن درخواست '} اطمینان دارید؟`,
    }
    setDialog({ title: data.title, content: data.content, open: false, onAccept: () => null });
  };
  const redirectToDetails = (rowData) => {
    navigate(`/ticket/${rowData.Id}/${rowData.PId}/${rowData.ProjectId}/detail?ticketCat=sale `, {
      state: rowData,
    });
  };

  const ChangeStateActionBtn = () => {
    return (
      <>
        <ButtonLoading
          type="submit"
          variant="contained"
          color="primary"
          loading={loadingBtn}
          name="بله"
          onClick={dialog?.onAccept}
        />

        <Button variant="contained" onClick={handleCloseDialog}>
          انصراف
        </Button>
      </>
    );
  };

  return (
    <PageContainer
      title='درخواست های مدیریت مشتریان پاد'
      breadcrumbs={constBreadCrumbsTitle.TICKET_SALE_LIST}
      className={classes.root}
    >

      <Grid item xs={12}>
        <Box display="flex" justifyContent='end' alignItems="flex-end" style={{ marginBottom: 16 }}>
          {actionsList['contentTicketListSalePage'] && (
            filters && (
              <FilterButton
                setOpenFilterDialog={setOpenFilterDialog}
                filters={filters}
              />
            )
          )}
          {actionsList['createTicketSalePage'] && (
            <Button color="primary" variant="contained" onClick={() => navigate('/Ticket/Create')}>
              ایجاد تیکت جدید
            </Button>
          )}
        </Box>
        {actionsList['contentTicketListSalePage'] && (
          filters && (
            <Box>
              <FilterPod
                filters={filters}
                onChange={onFiltersChange}
                openFilterDialog={openFilterDialog}
                setOpenFilterDialog={setOpenFilterDialog}
                handleCloseFilterDialog={handleCloseFilterDialog}
              />
            </Box>
          )
        )}
      </Grid>

      {categoryLoading ? (
        <LoadingPage />
      ) : (
        <>
          {actionsList['contentTicketListSalePage'] && (
            filters && (
              <TableComponents
                data={getList}
                columns={columns(
                  setDialog,
                  closeTicketRequest,
                  cancelTicketRequest,
                  redirectToDetails,
                  actionsList
                )}
                isLoading={loading}
                ref={tableRef}
                onChange={(ps) => {
                  setPage(ps?.pageNumber)
                  setSize(ps?.pageSize)
                  return getList(ps)
                }}
              />
            )
          )}
        </>
      )}

      <SimpleDialog
        title={dialog?.title}
        content={dialog?.content}
        open={dialog?.open || false}
        actions={<ChangeStateActionBtn />}
      />
    </PageContainer>
  );
}
export default TicketSale;
